import { Component, Input } from '@angular/core';
import { BarGraph } from '@app/interfaces/IGraphStyle';

@Component({
  selector: 'app-bar-chart',
  templateUrl: './bar-chart.component.html',
  styleUrls: ['./bar-chart.component.scss']
})

export class BarChartComponent {
  @Input() style: BarGraph;// style values to be passed from parent components 
  @Input() data: any; // graphdata coming from parent components 
  @Input() title: any;
  @Input() id: any;
  @Input() colorScheme: any; // colorscheme styling to be passed from parent component  

  productSales: any[] | undefined;
}